import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select'

import { fr, Locale, zhCN } from 'date-fns/locale'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export const dateLocales: Record<string, Locale> = {
  fr,
  'zh-CN': zhCN,
}

export const supportedLanguages = [
  { text: '🇨🇳 中文', value: 'zh-CN' },
  { text: '🇫🇷 Français', value: 'fr' },
]

export function LanguageSwitcher() {
  const navigate = useNavigate()
  const location = useLocation()
  const { i18n } = useTranslation()

  const changeUserLanguage = (locale: string) => {
    i18n.changeLanguage(locale)
    // 保持当前路径和查询参数不变
    navigate(location.pathname + location.search)
  }

  return (
    <div>
      <Select
        value={i18n.language}
        onValueChange={(value) => changeUserLanguage(value)}
      >
        <SelectTrigger className="border-none shadow-none focus:ring-0 focus:ring-ring hover:bg-accent">
          <SelectValue placeholder="" />
        </SelectTrigger>
        <SelectContent>
          {supportedLanguages.map(({ text, value }) => (
            <SelectItem value={value} key={value}>
              {text}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
